<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { get } from 'lodash';

import config from '@/config/config';
import { fetchDownloadCertificate } from '@/api/exam';

export default {
  name: 'ComponentsExam',
  data() {
    return {
      currentQuestion: 0,
      answer: null,
      isFinished: false,
      data: {
        firstName: null,
        lastName: null,
        email: null,
      },
    };
  },
  computed: {
    ...mapState(config.app, [
      'token',
      'course',
      'exam',
      'answers',
      'examResults',
    ]),
    questions() {
      return get(this, 'exam.questions', []);
    },
    totalQuestions() {
      return this.questions.length;
    },
    question() {
      return this.questions[this.currentQuestion];
    },
  },
  methods: {
    ...mapActions(config.app, [
      'fetchCourseExam',
      'fetchCourseExamResults',
    ]),
    ...mapMutations(config.app, [
      'addAnswer',
      'resetExam',
    ]),
    submitAnswer() {
      this.addAnswer({
        questionId: this.question.id,
        answerId: this.answer,
      });
      this.currentQuestion++;

      if (this.totalQuestions === this.currentQuestion) {
        this.isFinished = true;
      }
    },
    fetchResults() {
      this.fetchCourseExamResults(this.course.id);
    },
    reTry() {
      this.currentQuestion = 0;
      this.isFinished = false;
      this.answer = null;
      this.resetExam();
      this.fetchCourseExam(this.course.id);
    },
    downloadCertificate() {
      const payload = {
        id: this.examResults.certificate.id,
        code: this.token,
        firstName: this.data.firstName,
        lastName: this.data.lastName,
        email: this.data.email,
      };
      fetchDownloadCertificate(payload).then(function(t) {
        return t.blob().then((b) => {
          const a = document.createElement("a");
          a.href = URL.createObjectURL(b);
          a.setAttribute("download", 'certifikat.pdf');
          a.click();
        })
      });
    },
  },
  mounted() {
    this.fetchCourseExam(this.course.id);
  },
};
</script>
<style scoped>
  .selected {
    border: 1px solid black;
    background: #81D8D0;
  }
  button.submit {
    align-self: center;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: #312d2e;
    font-weight: 400;
    line-height: 1.5;
    padding: 0.15rem 0.25rem;
    background: #81d8d0;
    border: 0;
  }

  ul.exam-results li {
    padding: 5px 0;
    border-bottom: 1px solid grey;
  }

  ul.exam-results li:last-child {
    border-bottom: 1px transparent;
  }

  ul.exam-results li span {
    display: inline-block;
    font-weight: bold;
    width: 200px;
    padding: .5em 0;
  }

  input:focus {
    box-shadow: 0 0 0 0.2rem rgba(129, 216, 208, .5);
  }
</style>
<template>
    <div id="course-lecture">
      <h2>{{exam.title}}</h2>
      <p v-html="exam.description"></p>

      <div v-if="Object.keys(examResults).length === 0 && examResults.constructor === Object">
        <div v-if="question && !isFinished" class="mt-5">
          <h3>{{question.title}}</h3>
          <p v-html="question.description"></p>
          <ul class="answers">
            <li v-for="questionAnswer in question.answers"
                :key="questionAnswer.id"
                class="m-2 p-4 pointer border answer"
                :class="{ selected: answer === questionAnswer.id}"
                @click="answer = questionAnswer.id"
                v-html="questionAnswer.text"
            />
          </ul>
          <div class="text-right mt-5" v-if="answer">
            <button @click="submitAnswer()" class="submit">Dalej</button>
          </div>
        </div>
        <div v-if="isFinished" class="mt-5">
          <div class="text-center">
            <button class="submit" @click="fetchResults()">Przelicz swój wynik</button>
          </div>
        </div>
      </div>
      <div v-else class="d-flex flex-column">
        <ul class="exam-results">
          <li><span>Ilość pytań</span> {{ (examResults.correct || 0) + (examResults.wrong || 0)}}</li>
          <li><span>Poprawne odpowiedzi</span> {{examResults.correct || 0}}</li>
          <li><span>Błędne odpowiedzi</span> {{examResults.wrong || 0}}</li>
          <li><span>Wynik</span> {{examResults.rate}}%</li>
          <li v-if="examResults.passed" class="mt-5 text-center">
            <p>Zdałeś!</p>
            <p class="mt-3">Możesz wygenerować certyfikat wypełniając poniższe informacje</p>
          </li>
          <li v-else class="mt-5 text-center">
            Naciśnij <a href="#" class="font-weight-bold" @click.prevent="reTry()">tutaj</a> aby spróbować ponownie!
          </li>
        </ul>

        <div v-if="examResults.passed" class="mt-5">
          <div class="form-group offset-md-3 col-md-6 col-12">
            <label for="certificate-name">Imię</label>
            <input id="certificate-name" class="form-control" v-model="data.firstName" />
          </div>
          <div class="form-group offset-md-3 col-md-6 col-12">
            <label for="certificate-surname">Nazwisko</label>
            <input id="certificate-surname" class="form-control" v-model="data.lastName" />
          </div>
          <div class="form-group offset-md-3 col-md-6 col-12">
            <label for="certificate-email">Email</label>
            <input id="certificate-email" class="form-control" type="email" v-model="data.email" />
          </div>
          <div class="form-group text-center pt-3">
            <p>
              Potrzebujemy Twój adres e-mail,  aby wysłać Ci link niezbędny do wygenerowania e-certyfikatu.
              <br />
              Jeśli skasujesz otrzymaną wiadomość niezbędne będzie ponowne przystąpienie do egzaminu.
            </p>
            <button class="submit" @click.prevent="downloadCertificate()">Pobierz certyfikat</button>
          </div>
        </div>
      </div>
    </div>
</template>